import { AnimatePresence } from "motion/react";
import { useTranslation } from "next-i18next";
import { MotionBoxProps } from "src/components/base";
import { MotionBox } from "src/components/base";
import { IWfHeadingProps, WfHeading } from "src/components/base/wf-heading";
import { useRouterLocale } from "src/utils/router/use-router-locale";
import { addQuotationsToText } from "src/utils/string-util";

const headingStyles: IWfHeadingProps = {
    as: "h1",
    fontSize: ["3xl", "3xl", "4xl"],
    mb: "2",
    noOfLines: 1,
    wordBreak: "break-all",
};

const motionBoxStyle: MotionBoxProps = { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0, position: "absolute" } };

type IAnimatedHeading = {
    headline: string;
    searchTerm?: string | string[];
    isMobile?: boolean;
};

export const AnimatedHeading = ({ searchTerm, headline, isMobile }: IAnimatedHeading) => {
    const { t } = useTranslation("extended-search");
    const { language } = useRouterLocale();

    return (
        <>
            <AnimatePresence initial={false}>
                {searchTerm && (
                    <MotionBox {...motionBoxStyle}>
                        <WfHeading {...headingStyles} {...(isMobile ? { fontSize: "xl", mb: "3" } : { pb: "1", mb: "1" })}>
                            {isMobile ? addQuotationsToText(searchTerm as string, language) : t("headlines.results-for", { searchTerm })}
                        </WfHeading>
                    </MotionBox>
                )}
            </AnimatePresence>
            <AnimatePresence initial={false}>
                {searchTerm ? null : (
                    <MotionBox {...motionBoxStyle}>
                        <WfHeading {...headingStyles}>{headline}</WfHeading>
                    </MotionBox>
                )}
            </AnimatePresence>
        </>
    );
};
